import TrafficGroupDTO from "@/models/TrafficGroupDTO";

export default interface RequisiteGroupFormDTO {
    id: number|null
    name: string|null
    trafficGroups: TrafficGroupDTO[]
}

export const defaultForm = {
    id: null,
    name: '',
    trafficGroups: []
} as RequisiteGroupFormDTO

